import { Component, inject, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { NgbOffcanvas, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';
import { TableProviderService } from 'src/app/services/table-provider.service';

export type AdminBusinessFilter = 'all' | 'cemento' | 'hormigon';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-admin-nav',
  templateUrl: './admin-nav.component.html',
  styleUrls: ['./admin-nav.component.css'],
  providers: [TableProviderService, DecimalPipe],
})
export class AdminNavComponent {
  _opened = false;
  isAuthenticate: unknown;
  version: string;

  private readonly offcanvasService = inject(NgbOffcanvas);
  private offcanvasRef: NgbOffcanvasRef | null = null;

  readonly filterOptions: ReadonlyArray<{ id: AdminBusinessFilter; label: string }> = [
    { id: 'all', label: 'Todo' },
    { id: 'hormigon', label: 'Hormigón' },
    { id: 'cemento', label: 'Cemento' },
  ];

  readonly cementoLinks: ReadonlyArray<{ path: string; label: string }> = [
    { path: '/admin/cemento/cotizacion', label: 'Cotizaciones' },
    { path: '/admin/cemento/ventas', label: 'Ventas' },
    { path: '/admin/cemento/politicas-entrega', label: 'Políticas de entrega' },
    { path: '/admin/cemento/productos', label: 'Productos' },
    { path: '/admin/cemento/datos-geograficos', label: 'Datos geográficos' },
    { path: '/admin/cemento/centros-logisticos', label: 'Centros logísticos' },
    { path: '/admin/cemento/ejecutivos', label: 'Ejecutivos Cemento' },
    { path: '/admin/cemento/configuraciones', label: 'Configuración' },
  ];

  readonly hormigonLinks: ReadonlyArray<{ path: string; label: string }> = [
    { path: '/admin/products', label: 'Productos' },
    { path: '/admin/products-logs', label: 'Historial de precios' },
    { path: '/admin/plants', label: 'Plantas' },
    { path: '/admin/horario', label: 'Disponibilidad' },
    { path: '/admin/cotizacion', label: 'Cotizaciones' },
    { path: '/admin/sales', label: 'Ventas' },
    { path: '/admin/contacts', label: 'Contactos' },
    { path: '/admin/sap', label: 'SAP log' },
    { path: '/admin/settings', label: 'Configuraciones' },
    { path: '/admin/shifts', label: 'Días de entrega' },
    { path: '/admin/region', label: 'Regiones' },
    { path: '/admin/comuna', label: 'Comunas' },
    { path: '/admin/executives', label: 'Ejecutivos' },
    { path: '/admin/comuna_plant', label: 'Planta por comuna' },
    { path: '/admin/user', label: 'Usuarios' },
  ];

  businessFilter: AdminBusinessFilter = 'all';
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly authenticationService: AuthenticationService) {
    this.version = environment.version;
    this.route.firstChild?.data.subscribe((params) => {
      this.isAuthenticate = params['isAuthenticate'];
    });
  }

  closeOffcanvas(): void {
    this.offcanvasRef?.close();
    this.offcanvasRef = null;
  }

  openOffcanvas(sidebar: TemplateRef<unknown>): void {
    this.offcanvasRef = this.offcanvasService.open(sidebar, {
      ariaLabelledBy: 'offcanvas-basic-title',
      animation: true,
      panelClass: 'admin-nav-offcanvas-host',
    });
  }

  setBusinessFilter(value: AdminBusinessFilter): void {
    this.businessFilter = value;
  }

  showCementoSection(): boolean {
    return this.businessFilter === 'all' || this.businessFilter === 'cemento';
  }

  showHormigonSection(): boolean {
    return this.businessFilter === 'all' || this.businessFilter === 'hormigon';
  }

  showSectionHeadings(): boolean {
    return this.businessFilter === 'all';
  }

  trackByPath(_index: number, item: { path: string }): string {
    return item.path;
  }

  trackByFilterId(_index: number, item: { id: AdminBusinessFilter; label: string }): AdminBusinessFilter {
    return item.id;
  }

  logMenuNavigation(_path: string): void {
    /* Reservado para trazabilidad de navegación (p. ej. analytics). */
  }

  get existUser(): boolean {
    return this.authenticationService.isAdminAuthenticated;
  }

  closeSession(): void {
    this.closeOffcanvas();
    this.authenticationService.logout().subscribe({
      next: () => void this.router.navigateByUrl('/admin/login'),
      error: () => void this.router.navigateByUrl('/admin/login'),
    });
  }
}
